import { Component, ElementRef, OnInit, QueryList, TemplateRef, ViewChild, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LearningHubService } from '../../services/learning-hub.service';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { AgmMap, } from '@agm/core';
import { BannersInfoTabService } from 'src/app/modules/dashboard/modules/banners/services/banners-info-tab-service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastService } from 'src/app/core/toast.service';
import { CourseSectionService } from '../../../profile/services/course-section.service';
import { LoginService } from 'src/app/core/services/login.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatePipe, ViewportScroller } from '@angular/common';

@Component({
  selector: 'app-learning-hub-details',
  templateUrl: './learning-hub-details.component.html',
  styleUrls: ['./learning-hub-details.component.scss'],
})
export class LearningHubDetailsComponent implements OnInit {
  constructor(
    private activeRoute: ActivatedRoute,
    private route: ActivatedRoute,
    private router: Router,
    private LearningHubService: LearningHubService,
    private bannersInfoTabService: BannersInfoTabService,
    private fb: FormBuilder,
    private loginService: LoginService,
    private CourseSectionService: CourseSectionService,
    private toast: ToastService,
    private spinner: NgxSpinnerService,
    private viewportScroller: ViewportScroller,
    private datePipe: DatePipe
  ) { }

  @ViewChildren('leftNavSlide') leftNavBNSlideRefs!: QueryList<ElementRef>;
  @ViewChild('confirmRedirectDialog') confirmRedirectDialog!: TemplateRef<any>;
  leftNavBNObservers: IntersectionObserver[] = [];
  leftNavviewedBNIds: Set<number>[] = [];

  @ViewChild(AgmMap, { static: true }) map: AgmMap;
  @ViewChildren('bannerVideo') videos!: QueryList<ElementRef<HTMLVideoElement>>;

  // Hedaer banner  Video and Image
  headerBannerSwiperConfig: SwiperConfigInterface = {
    slidesPerView: 1,
    effect: 'fade',
    fadeEffect: { crossFade: true }, //
    speed: 400,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
    loop: true,
  };

  //
  // Gallery swiper
  relatedCourseSwiperConfig: SwiperConfigInterface = {
    slidesPerView: 1,
    effect: 'fade',
    fadeEffect: { crossFade: true }, //
    speed: 800,
    autoplay: {
      delay: 2000,
      disableOnInteraction: false,
    },
    loop: true,
  };

  // event swiper
  eventSwiperConfig: SwiperConfigInterface = {
    slidesPerView: 1,
    effect: 'fade',
    fadeEffect: { crossFade: true }, //
    speed: 800,
    autoplay: {
      delay: 2000,
      disableOnInteraction: false,
    },
    loop: true,
  };

  // Gallery swiper
  gallerySwiperConfig: SwiperConfigInterface = {
    slidesPerView: 1,
    effect: 'fade',
    fadeEffect: { crossFade: true }, //
    speed: 800,
    autoplay: {
      delay: 2000,
      disableOnInteraction: false,
    },
    loop: true,
  };

  // banner
  bannerSwiperConfig: SwiperConfigInterface = {
    slidesPerView: 1,
    effect: 'fade',
    fadeEffect: { crossFade: true }, //
    speed: 400,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
    loop: true,
  };

  loginDetails: any;

  limit = 5;
  offset = 0;
  allRelatedCoursesData: any[] = [];
  dataLoaded = false; //--banner -condition 0 data
  loading = false;
  endOfData = false;
  courseType: any;
  active_status: string = 'ACTIVE';
  status: string = 'APPROVE';
  courseDetailsId: any;
  selectedCourse: any;
  registerForm!: FormGroup;
  courseId!: string;
  showPopup: boolean = false;
  showRegisterForm: boolean = true;
  isRegistered: boolean = false;

  // banners
  bannerList: any;
  categoryList: any;
  filteredBannerList: any[] = [];
  leftNavBannerData: any[] = [];
  leftNavTimer: number = 1000;

  submitted = false;

  ngOnInit(): void {
    this.spinner.show();


    this.route.queryParams.subscribe((params) => {
      const section = params['scroll'];
      if (section) {
        // Delay to ensure view is rendered before scrolling
        setTimeout(() => this.scrollToSection(section), 100);
      }
    });
    this.loginDetails = this.loginService.getLoginData();
    this.activeRoute.params.subscribe((params) => {
      this.courseId = params['id'];
      this.selectedCourse = null;

      this.LearningHubService.getCourseByid(
        params.id,
        this.loginDetails.id
      ).subscribe({
        next: (data: any) => {

          const fullAddress = data.address;

          this.selectedCourse = {
            ...data,
            startTime: data.startTime ? this.convertTimeStringToDate(data.startTime) : null,
            endTime: data.endTime ? this.convertTimeStringToDate(data.endTime) : null,
            city: ''
          };


          this.getCityFromGoogle(fullAddress).then(cityName => {
            this.selectedCourse.city = cityName;
          });


          //  Calculate sold-out status
          const registeredCount = data.course_registered_users_aggregate.aggregate.count;
          const remainingSeats = data.number_of_seats - registeredCount;
          const isSoldOut = remainingSeats <= 0;
          this.isRegistered = this.isUserAlreadyRegistered();
          // this.showRegisterForm = !this.isUserAlreadyRegistered() && !isSoldOut;
          this.getCoordinatesFromAddress(this.selectedCourse?.address);

          this.courseType = data?.type;
          this.courseDetailsId = data?.id;
          this.endOfData = false;
          this.dataLoaded = false;

          this.allRelatedCoursesData = [];
          this.offset = 0;
          this.limit = 5;
          this.loadMoreCourses();
          this.getBannersCategory();
          this.getFilteredBanners();

          this.spinner.hide();
        },
        error: (err) => {
          this.spinner.hide();
        },
      });
    });

    // Initialize form
    this.registerForm = this.fb.group({
      first_name: ['', Validators.required],
      last_name: ['', Validators.required],
      phone_number: ['', [Validators.required, Validators.pattern(/^\+?[0-9]{10,15}$/)]],
      email: ['', [Validators.required, Validators.email]],
      description: [''],
    });
  }

  private convertTimeStringToDate(time?: string | null): Date | null {
    if (!time) {
      return null; // nothing to convert
    }
    const cleaned = time.replace(/\+.*/, '');      // remove +00 etc.
    return new Date(`1970-01-01T${cleaned}`);
  }

  get formattedDateRange(): string {
    const start = this.selectedCourse?.startDate;
    const end = this.selectedCourse?.endDate;

    if (!start || !end) return '';

    const s = new Date(start);
    const e = new Date(end);

    const day = this.datePipe.transform(s, 'd (EEE)')!;
    const month = this.datePipe.transform(s, 'MMMM')!;
    const year = this.datePipe.transform(s, 'yyyy')!;

    //  Same exact calendar day
    if (s.getFullYear() === e.getFullYear() &&
      s.getMonth() === e.getMonth() &&
      s.getDate() === e.getDate()) {
      return `${day} ${month} ${year}`;
    }

    // Same month & year
    if (
      this.datePipe.transform(s, 'MMMM') === this.datePipe.transform(e, 'MMMM') &&
      year === this.datePipe.transform(e, 'yyyy')
    ) {
      return `${day} – ${this.datePipe.transform(e, 'd (EEE)')} ${month} ${year}`;
    }

    // Same year, different month
    if (year === this.datePipe.transform(e, 'yyyy')) {
      return `${day} ${month} – ${this.datePipe.transform(e, 'd (EEE)')} ${this.datePipe.transform(e, 'MMMM')} ${year}`;
    }

    // Different year
    return `${day} ${month} ${year} – ${this.datePipe.transform(e, 'd (EEE)')} ${this.datePipe.transform(e, 'MMMM')} ${this.datePipe.transform(e, 'yyyy')}`;
  }


  private getCityFromGoogle(address: string): Promise<string> {
    return new Promise((resolve) => {
      const geoCoder = new google.maps.Geocoder();
      geoCoder.geocode({ address }, (results, status) => {
        if (status === google.maps.GeocoderStatus.OK && results?.length) {
          const components = results[0].address_components;
          // Try locality first
          const city =
            components.find(c => c.types.includes('locality'))?.long_name ||
            components.find(c => c.types.includes('postal_town'))?.long_name ||
            components.find(c => c.types.includes('administrative_area_level_2'))?.long_name ||
            '';
          resolve(city);
        } else {
          resolve(''); // fallback empty string
        }
      });
    });
  }



  isUserAlreadyRegistered(): boolean {
    if (!this.selectedCourse) {
      return false;
    }
    const alreadyRegistered = this.selectedCourse.course_registered_users?.some(
      (user: any) => user.from_id === this.loginDetails.id
    );


    return alreadyRegistered;
  }

  ngAfterViewInit() {
    this.muteAllVideos();
    this.videos.changes.subscribe(() => {
      this.muteAllVideos();
    });

    this.leftNavBNSlides();
    this.leftNavBNSlideRefs.changes.subscribe(() => {
      this.leftNavBNSlides();
    });
  }
  scrollToSection(sectionId: string) {
    this.viewportScroller.scrollToAnchor(sectionId);
  }

  private muteAllVideos() {
    this.videos.forEach((video) => {
      video.nativeElement.muted = true; // force mute
      video.nativeElement.volume = 0; // extra safeguard
    });
  }

  loadMoreCourses(): void {
    if (this.loading || this.endOfData) return;

    this.loading = true;

    this.LearningHubService.getAllRelatedCourse(
      this.limit,
      this.offset,
      this.courseType,
      this.status,
      this.active_status,
      this.courseDetailsId
    ).subscribe((res: any) => {
      const newCourses = res || [];

      if (newCourses.length < this.limit) {
        this.endOfData = true;
      }

      // Deduplicate by id
      const existingIds = new Set(this.allRelatedCoursesData.map(c => c.id));
      const uniqueNewCourses = newCourses.filter(c => !existingIds.has(c.id));

      this.allRelatedCoursesData = [
        ...this.allRelatedCoursesData,
        ...uniqueNewCourses,
      ];

      this.offset += this.limit;
      this.loading = false;
      this.dataLoaded = true;
    });
  }


  trackByCourse(index: number, item: any): string {
    return item.id;
  }


  // earlybid price

  earlybidPrice(selectedCourse: any): boolean {
    if (!selectedCourse?.early_bird_end_date) return false;

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const endDate = new Date(selectedCourse.early_bird_end_date);
    endDate.setHours(0, 0, 0, 0);

    return endDate >= today;
  }

  // list banner new

  public listViewBNSwiperConfig: SwiperConfigInterface = {
    direction: 'horizontal',
    slidesPerView: 1,
    speed: 2000,
    spaceBetween: 15,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    keyboard: true,
    loop: true,
    longSwipes: true,
    // Disable preloading of all images
    preloadImages: false,
    // Enable lazy loading
    lazy: false,
    // autoplay: true,
    slidesOffsetAfter: 0,
    pagination: true,

    breakpoints: {
      240: {
        slidesPerView: 1,
      },
      600: {
        slidesPerView: 1,
      },
      768: {
        slidesPerView: 1,
      },
      991: {
        slidesPerView: 1,
      },
      1200: {
        slidesPerView: 1,
      },
    },
  };

  getFilteredBanners(): void {
    const filters = {
      status: 'APPROVED',
      category_names: ['All Left Nav Small Banners'],
      banner_location: ['Web Left Nav Talent Profile List'],
    };

    this.bannersInfoTabService.getFilteredBannersData(filters).subscribe({
      next: (data) => {
        this.bannerList = data;
        this.filterBannersByCategory();
      },
    });
  }

  getBannersCategory() {
    this.bannersInfoTabService.getBannersCategoryDatas().subscribe((data) => {
      this.categoryList = data;

      const FindLeftNavTimer = data.find(
        (category) => category?.name === 'All Left Nav Small Banners'
      )?.timer;

      this.updateLeftNavTimer(FindLeftNavTimer);
    });
  }

  filterBannersByCategory() {
    if (!this.bannerList) return;

    // Filter Header job seek ocation -Website Header Banner
    const today = new Date().toISOString().split("T")[0] + "T00:00:00+00:00";

    // Filter- 	Website List View Banner

    const FilterLeftNavBanner = this.bannerList.filter(
      (banner) =>
        banner?.category_name === 'All Left Nav Small Banners' &&
        banner.schedule_date <= today
    );

    const isAdminExistLeft = FilterLeftNavBanner.some(
      (b) => b.company_name === 'ADMIN'
    );

    const FilterLeftNavBannerData = FilterLeftNavBanner.filter((banner) =>
      isAdminExistLeft
        ? banner.company_name === 'ADMIN'
        : banner.company_name !== 'ADMIN'
    );

    this.leftNavBannerData = [];
    FilterLeftNavBannerData.forEach((banner) => {
      banner.image?.forEach((img) => {
        this.leftNavBannerData.push({
          img,
          id: banner.id,
          url: banner.url,
          category_name: banner.category_name,
          views: banner.views,
          banner_name: banner.banner_name,
        });
      });
    });
  }

  leftNavRandomSwiperConfig(i: number) {
    const config = { ...this.leftNavDynamicSwiperConfig() };
    config.initialSlide = Math.floor(i / 2) % this.leftNavBannerData.length;
    return config;
  }

  leftNavDynamicSwiperConfig(): SwiperConfigInterface {
    // Always return a new object to avoid shared state
    return { ...this.leftNavBNSwiperConfig };
  }

  public leftNavBNSwiperConfig: SwiperConfigInterface = {
    direction: 'horizontal',
    slidesPerView: 1,
    speed: 2000,
    spaceBetween: 15,
    autoplay: {
      delay: this.leftNavTimer,
      disableOnInteraction: false,
    },
    keyboard: true,
    loop: true,
    longSwipes: true,
    // Disable preloading of all images
    preloadImages: false,
    // Enable lazy loading
    lazy: false,
    // autoplay: true,
    slidesOffsetAfter: 0,
    pagination: true,

    breakpoints: {
      240: {
        slidesPerView: 1,
      },
      600: {
        slidesPerView: 1,
      },
      768: {
        slidesPerView: 1,
      },
      991: {
        slidesPerView: 1,
      },
      1200: {
        slidesPerView: 1,
      },
    },
  };

  updateLeftNavTimer(newDelay: number): void {
    this.leftNavTimer = Number(newDelay) * 1000;

    this.leftNavBNSwiperConfig = {
      ...this.leftNavBNSwiperConfig,
      autoplay: {
        delay: this.leftNavTimer,
        disableOnInteraction: false,
      },
    };
  }

  // Left Nav Views
  private leftNavBNSlides() {
    // Clear previous tracking
    this.leftNavviewedBNIds = [];

    const allSlides = this.leftNavBNSlideRefs.toArray();
    const bannersPerSwiper = 1; // each swiper is injected every 5 items (update if needed)

    let swiperIndex = -1;
    for (let i = 0; i < allSlides.length; i++) {
      if (i % this.leftNavBannerData.length === 0) {
        swiperIndex++;
        this.leftNavviewedBNIds[swiperIndex] = new Set<number>();
      }

      this.observeLeftNavSingleBanner(
        allSlides[i],
        this.leftNavBannerData[i % this.leftNavBannerData.length],
        this.leftNavviewedBNIds[swiperIndex],
        swiperIndex
      );
    }
  }

  private observeLeftNavSingleBanner(
    slideRef: ElementRef,
    banner: any,
    viewedIds: Set<number>,
    swiperIndex: number
  ) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (banner && !viewedIds.has(banner.id)) {
              banner.views = (banner.views || 0) + 1;
              viewedIds.add(banner.id);

              const viewscount = { views: banner.views };
              this.bannersInfoTabService
                .updateBanner(banner.id, viewscount)
                .subscribe();
            }
          }
        });
      },
      { threshold: 0.5 }
    );

    observer.observe(slideRef.nativeElement);
    this.leftNavBNObservers.push(observer);
  }

  // register submit

  onSubmit() {


    this.submitted = true;

    if (this.registerForm.invalid) {
      // Mark all controls as touched so validation messages appear
      Object.values(this.registerForm.controls).forEach((control) => {
        control.markAsTouched();
      });
      return;
    }

    const payload = {
      course_id: this.courseId,
      from_id: this.loginDetails.id,
      ...this.registerForm.value,
    };

    this.LearningHubService.getRegisteredCount(this.courseId).subscribe((count: any) => {


      const remainingSeats = this.selectedCourse?.number_of_seats - count;


      const isSoldOut = remainingSeats <= 0;


      if (isSoldOut) {

        this.toast.openSnackBar('Registration is full');
      }
      else {
        this.CourseSectionService.registerUser(payload).subscribe({
          next: (res) => {
            // this.toast.openSnackBar('Successfully registered!');
            this.registerForm.reset();
            this.submitted = false;
            this.showPopup = true;
            // this.showRegisterForm = false;
            this.isRegistered = true;
          },
          error: (err) => {
            console.error('Error:', err);
            this.toast.openSnackBar('Unable to Register!');
          },
        });

      }
    });


  }

  // openConfirmPopup() {
  //   if (this.registerForm.valid) {             
  //     this.showPopup = true; // Open popup first
  //   } else {
  //     this.toast.openSnackBar('Please fill all required fields');
  //   }
  // }

  closeChatPopup() {
    this.showPopup = false;
  }

  confirmRegistration() {

    // Redirect after successful registration
    if (this.selectedCourse?.register_link) {
      let url = this.selectedCourse.register_link;
      if (!/^https?:\/\//i.test(url)) {
        url = 'https://' + url;
      }
      window.open(url, '_blank');
    }
    this.showPopup = false;
  }

  // mapa ddress:

  lat!: number;
  lng!: number;

  getCoordinatesFromAddress(address: string) {

    const geocoder = new google.maps.Geocoder();

    geocoder.geocode({ address: address }, (results: any, status: any) => {
      if (status === google.maps.GeocoderStatus.OK) {
        this.lat = results[0].geometry.location.lat();
        this.lng = results[0].geometry.location.lng();
      } else {
        console.error('Geocode failed: ' + status);
      }
    });
  }
}
